var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "v-app",
        [
          this.$route.path != "/"
            ? _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "", fixed: "", app: "" } },
                [
                  _c("v-toolbar-side-icon", {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.drawer = !_vm.drawer
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("v-toolbar-title", [_vm._v(_vm._s(this.$route.name))]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    { staticClass: "hidden-sm-and-down" },
                    [
                      _c(
                        "v-btn",
                        { attrs: { flat: "" }, on: { click: _vm.logout } },
                        [_vm._v("Logout")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          this.$route.path != "/"
            ? _c(
                "v-navigation-drawer",
                {
                  attrs: { absolute: "", temporary: "" },
                  model: {
                    value: _vm.drawer,
                    callback: function($$v) {
                      _vm.drawer = $$v
                    },
                    expression: "drawer"
                  }
                },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-title", { staticClass: "title" }, [
                            _vm._v("\n              DIY Blinds\n            ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticClass: "pt-0", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-group",
                        { attrs: { "prepend-icon": "dashboard" } },
                        [
                          _c(
                            "v-list-tile",
                            { attrs: { slot: "activator" }, slot: "activator" },
                            [_c("v-list-tile-title", [_vm._v("Dashboard")])],
                            1
                          ),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["manager"].includes(_vm.loggedInUser.position.role)
                            ? _c(
                                "v-list-tile",
                                { attrs: { to: { path: "/dashboard/sales" } } },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [_vm._v("Sales")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["sales"].includes(_vm.loggedInUser.position.role)
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: { to: { path: "/dashboard/my-sales" } }
                                },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("My Sales")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["installations", "manager"].includes(
                            _vm.loggedInUser.position.role
                          )
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: {
                                    to: { path: "/dashboard/installation" }
                                  }
                                },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Installation")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["account", "manager"].includes(
                            _vm.loggedInUser.position.role
                          )
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: { to: { path: "/dashboard/account" } }
                                },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Account")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["manager"].includes(_vm.loggedInUser.position.role)
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: {
                                    to: { path: "/dashboard/motorisation" }
                                  }
                                },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Motorisation")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["manager"].includes(_vm.loggedInUser.position.role)
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: { to: { path: "/dashboard/samples" } }
                                },
                                [
                                  _c("v-list-tile-action"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Samples")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/customers" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("face")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Customers")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/carts" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("shopping_cart")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Carts")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/quotes" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("assignment")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Quotes")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/orders" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("assignment")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Orders")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/sentToTWC" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("assignment")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Sent to TWC")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/freeSamples" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("redeem")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Free Samples")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { to: { path: "/archive" } } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("archive")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Archive")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-group",
                        { attrs: { "prepend-icon": "settings" } },
                        [
                          _c(
                            "v-list-tile",
                            { attrs: { slot: "activator" }, slot: "activator" },
                            [_c("v-list-tile-title", [_vm._v("Admin")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/tomaxzones" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Tomax Zones")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/customCurtains" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Custom Curtain Calculator")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/postcodes" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [_vm._v("Postcodes")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/promocodes" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Promocodes")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/installprices" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Installprices")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/fabricCategories" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Fabric Categories")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/fabrics" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [_c("v-list-tile-title", [_vm._v("Fabrics")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/freeSamplePacks" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Free Sample Packs")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/updatePassword" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Update Password")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.loggedInUser.position &&
                          ["manager"].includes(_vm.loggedInUser.position.role)
                            ? _c(
                                "v-list-tile",
                                { attrs: { to: { path: "/sales-users" } } },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Sales User")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/orderDetails" } } },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Order Details")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/import/customers" } } },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("cloud_upload")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Import Customers")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/import/orders" } } },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("cloud_upload")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Import Orders")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { to: { path: "/import/items" } } },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("cloud_upload")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Import Items")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-content", [_c("router-view")], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 